import { UrlActionTypes } from '../../../enums/ActionEnums';
export const urlActions = {
    updatePage: (page) => ({
        type: UrlActionTypes.UPDATE_PAGE,
        payload: page,
    }),
    updateSize: (size) => ({
        type: UrlActionTypes.UPDATE_SIZE,
        payload: size,
    }),
    updateSort: (sortOption) => ({
        type: UrlActionTypes.UPDATE_SORT,
        payload: sortOption,
    }),
    updateStoreId: (storeId) => ({
        type: UrlActionTypes.UPDATE_STORE_ID,
        payload: storeId,
    }),
    setUrlParams: (urlState) => ({
        type: UrlActionTypes.SET_URL_PARAMS,
        payload: urlState,
    }),
};
